/**
 * Shared by `sort-radios.shared.ts` and `view-toggle.shared.ts` — both run the same "drop anything
 * malformed" gate over an authored `value`/`label` pair.
 */
export function isNonBlank(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}
